import { Theme } from '@mui/material';
import Alert from './Alert';
import Autocomplete from './Autocomplete';
import Button from './Button';
import Card from './Card';
import Input from './Input';
import Link from './Link';
import Switch from './Switch';
import Table from './Table';
import Tabs from './Tabs';

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme: Theme) {
  return Object.assign(
    Alert(),
    Autocomplete(),
    Button(theme),
    Card(),
    Input(),
    Link(),
    Switch(theme),
    Table(theme),
    Tabs()
  );
}
